import React, { useState, useEffect } from "react";
import { AccountMenu } from "./Component/AccountMenu";
import "../node_modules/video-react/dist/video-react.css";
import { useUser } from "./Provider/UserProvider";
import "./Component/Asset.css";
import { useNavigate } from "react-router-dom";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import { OrganizationMemberSelectBox } from "./Component/OrganizationMemberSelectBox";
import ReportedUserListDataTable from "./Component/ReportedUserListDataTable";
import { Grid } from "@mui/material";
import { API_DOMAIN_URL } from "./Common";

export function History() {
  const { user } = useUser();

  //console.log(user);
  //console.log(setUser);
  const navigate = useNavigate();

  const [organizationUsers, setOrganizationUsers] = useState(null);
  const [orgUser, setOrgUser] = useState();
  useEffect(() => {
    if (orgUser && orgUser.id) {
      getReportedUserList(orgUser);
    }
  }, [orgUser]);
  //const [ownedGroups, setOwnedGroups] = useState();
  //const [targetGroup, setTargetGroup] = useState();
  const [reportedUserList, setReortedUserList] = useState();

  const authCheck = () => {
    if (!user || !user.id || user.id == "error") {
      navigate("/SignIn");
      return false;
    }
    return true;
  };

  const getOrganizationUsers = () => {
    // get organization users data
    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL +
      `/api/GetOrganizationUsers?code=${code}&UserId=${user.id}`;
    //console.log(url);
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        //console.log(response);
        //response.push(user);
        setOrganizationUsers(response);
      })
      .catch(() => {
        //console.error();
        console.log("History OrganizationUsers Exception");
        let orgUsers = [];
        orgUsers.push(user);
        setOrganizationUsers(orgUsers);
      });
  };

  const getReportedUserList = (orgUser) => {
    // get organization users data
    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL +
      `/api/GetReportedUserIdsPerYearMonth?code=${code}&UserId=${orgUser.id}`;
    //console.log(url);
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        //console.log(response);
        setReortedUserList(response);
      })
      .catch(() => {
        console.log("error ocuuerd in fetching");
      });
  };

  useEffect(() => {
    if (authCheck()) {
      getOrganizationUsers();
    }
  }, []);

  return (
    <div className="asset-list-root">
      <AccountMenu />
      <Container component="main" maxWidth="md">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item md={4}>
              <Typography component="h1" variant="h5">
                利用状況
              </Typography>
            </Grid>
            <Grid item md={8}></Grid>

            <Grid item md={3} mt={1}>
              <OrganizationMemberSelectBox
                orgUsers={organizationUsers}
                setOrgUser={setOrgUser}
                setShowAddBtn={null}
              />
            </Grid>
            <Grid item md={9} mt={1}></Grid>
          </Grid>

          <ReportedUserListDataTable
            orgUser={orgUser}
            reportedUserList={reportedUserList}
          />
        </Box>
      </Container>
    </div>
  );
}
